<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <span class="note"><i style="color: red">*</i> 确定要取消当前手术吗？</span>
            <div>
                <el-input style="margin-top: 30px" type="textarea" :rows="2" placeholder="请输入取消手术原因" v-model="textarea" @blur="check"></el-input>
            </div>
        </div>
        <CloseButton type="confirm" @confirm="surgeryReturn" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `surgeryReturn`,
    props: {

    },
    data() {
        return {
            title: `误入取消`,
            token: this.$route.query.token,
            id: this.$route.query.surgery_id,
            recordType: this.$route.query.recordType,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            data: {},
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
    },
    methods: {
        surgeryReturn() {
            let that = this
            if (!that.check()) return false
            return new Promise((resolve) => {
                let req = that.myaxios.put(`/api/Intraoperative/Anaesthesia/ReturnOperation/${this.$route.query.surgery_id}?reason=${this.textarea}`)
                req.then(data => {
                    that.data = { surgeryId: this.$route.query.surgery_id }
                    that.msg = `ok`
                    that.sendMessage()
                    if (that.AfterOtherEventClickProc) {
                        that.afterExecProc()
                    }
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.textarea === ``) {
                this.$message.warning(`退回排程原因不能为空`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        // 手术终止后处理
        afterExecProc() {
            let that = this
            return new Promise((resolve) => {
                let req = this.myaxios.post(`/api/Intraoperative/Anaesthesia/AfterOtherEventProc?surgeryId=${that.id}&recordType=${that.recordType}&actionType=误入取消`)
                req.then(data => {
                }).catch(e => { console.log(e) })
            })
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SurgeryReturn.vue